<template>
  <div>
    <div v-if="threeMonthAverageLoading" class="three-month-average-grid">
      <LoadingSpinner
        class="three-month-loading-spinner"
        :loading="threeMonthAverageLoading"
        :size="'100px'"
        :color="'#70A300'"
        :borderWidth="'6px'"
      />
    </div>
    <v-container v-else class="three-month-average-grid">
      <v-row class="mt-0">
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-cpl-title three-month-average-title center">
            {{ data[0].cpl_month }} CPL
          </div>
        </v-col>
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-cph-title three-month-average-title center">
            {{ data[0].cph_month }} CPH
          </div>
        </v-col>
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-lth-title three-month-average-title center">
            {{ data[0].cph_month }} LTH
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-cpl-value three-month-average-value center">
            ${{ data[0].current_month_cpl }}
          </div>
        </v-col>
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-cph-value three-month-average-value center">
            ${{ data[0].current_month_cph }}
          </div>
        </v-col>
        <v-col cols="sm" class="pb-0">
          <div class="three-month-average-lth-value three-month-average-value center">
            {{ data[0].current_month_lth }}
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-cpl-mom subtext center ">
            <UpOrDownArrow
              :up="data[0].mom_cpl >= 0"
              :color="data[0].mom_cpl >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />
            {{ data[0].mom_cpl }}% MoM
          </span>
        </v-col>
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-cph-mom subtext center">
            <UpOrDownArrow
              :up="data[0].mom_cph >= 0"
              :color="data[0].mom_cph >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />{{ data[0].mom_cph }}% MoM
          </span>
        </v-col>
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-lth-mom subtext center">
            <UpOrDownArrow
              :up="data[0].mom_lth >= 0"
              :color="data[0].mom_lth >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />{{ data[0].mom_lth }}% MoM
          </span>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-cpl-yoy subtext center">
            <UpOrDownArrow
              :up="data[0].yoy_cpl >= 0"
              :color="data[0].yoy_cpl >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />{{ data[0].yoy_cpl }}% YoY
          </span>
        </v-col>
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-cph-yoy subtext center">
            <UpOrDownArrow
              :up="data[0].yoy_cph >= 0"
              :color="data[0].yoy_cph >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />{{ data[0].yoy_cph }}% YoY
          </span>
        </v-col>
        <v-col cols="sm" class="mt-0 pt-0 mb-0 mt-0 pb-0">
          <span class="three-month-average-lth-yoy subtext center">
            <UpOrDownArrow
              :up="data[0].yoy_lth >= 0"
              :color="data[0].yoy_lth >= 0 ? '#666666' : '#70A300'"
              :size="'50px'"
            />{{ data[0].yoy_lth }}% YoY
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import UpOrDownArrow from '../StyledComponents/UpOrDownArrow.vue';
import LoadingSpinner from '../StyledComponents/LoadingSpinner.vue';

export default {
  name: 'TrendsThreeMonthAverage',
  components: {
    UpOrDownArrow,
    LoadingSpinner,
  },
  props: {
    data: { type: Array, requried: true },
  },
  computed: {
    threeMonthAverageLoading() {
      return this.$store.state.trends.threeMonthAverageLoading;
    },
  },
};
</script>
